import {
    AfterViewInit,
    Component,
    ElementRef,
    Input,
    OnChanges,
    OnInit,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import { VideoComponent, WhiteboardDrawing } from '@lemberger/whiteboards';
import { ApplicationStateService } from '../../../../../../services/application-state.service';
import { ModalableWhiteboardVideo } from '../../../../../../models/modalable-whiteboard-video';
import { BookviewerWhiteboardDrawingsService } from '../../../../../../services/bookviewer-whiteboard-drawings.service';
import { ModalComponent } from '../../../../../../models/modal-component';
import { SharingOptionsComponent } from '../../../../../utils/sharing-options/sharing-options.component';

@Component({
    selector: 'app-whiteboard-video-modal',
    templateUrl: './whiteboard-video-modal.component.html',
    styleUrls: ['./whiteboard-video-modal.component.scss'],
    imports: [
        SharingOptionsComponent,
        VideoComponent
    ],
    standalone: true
})
export class WhiteboardVideoModalComponent extends ModalComponent implements OnChanges, OnInit, AfterViewInit {
    @Input() declare modalable: ModalableWhiteboardVideo;
    whiteboardDrawing: WhiteboardDrawing;
    @ViewChild('video') video: VideoComponent;
    @ViewChild('modal') modal: ElementRef;
    videoError = false;

    constructor(
        public applicationStateService: ApplicationStateService,
        private whiteboardService: BookviewerWhiteboardDrawingsService) {
        super();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.castWhiteboard();
    }

    ngOnInit(): void {
        this.castWhiteboard();
    }

    ngAfterViewInit(): void {
        this.loadVideo();
        $(this.modal.nativeElement).on('shown.bs.modal', () => {
            this.video.videoPlayer.nativeElement.play();
        });
        $(this.modal.nativeElement).on('hide.bs.modal', () => {
            this.stopVideo();
        });
    }

    stopVideo(): void {
        if (this.videoError) {
            return;
        }

        this.video.videoPlayer.nativeElement.pause();
        this.video.videoPlayer.nativeElement.currentTime = 0;
    }

    generateLink(): string {
        // eslint-disable-next-line max-len
        return `${this.applicationStateService.baseUrl}/digibuecher/whiteboard/${this.modalable.id}/${this.modalable.book_id}/${this.modalable.sharing_link}`;
    }

    getId(): string {
        return this.modalable.getModalId();
    }

    private castWhiteboard(): void {
        this.whiteboardDrawing = this.modalable.asWhiteboardDrawing();
    }

    private loadVideo(): void {
        this.whiteboardService.downloadVideo(this.modalable.book_id, this.modalable).subscribe(blob => {
                this.video.videoPlayer.nativeElement.src = window.URL.createObjectURL(blob as Blob);
            }
        );
    }
}
